<div class="pt-transactions">
  <div class="pt-transactions__header">
    <h1 class="pt-transactions__h1">
      {{ 'transactions.title' | translate }}
    </h1>
    <div class="pt-transactions__filters">
      @if (forTeam()) {
        <swiper
          class="pt-transactions__bonus-tabs pu-swiper-gap-16"
          [config]="swiperConfig"
        >
          @for (metric of metrics() | withAllOption; track metric.id) {
            <button
              [class.pu-button_pressed]="filtersForm.controls.metric.value === metric.id"
              *swiperSlide
              type="button"
              puButton
              uiType="gradient"
              size="s"
              (click)="changeMetric(metric)"
            >
              {{ metric.name }}
            </button>
          }
        </swiper>
      } @else {
        <div class="pt-transactions__tabs">
          @for (direction of transactionDirections | withAllOption; track direction.id) {
            <button
              [class.pu-button_pressed]="filtersForm.controls.direction.value === direction.id"
              type="button"
              puButton
              uiType="gradient"
              size="s"
              (click)="changeDirection(direction)"
            >
              {{ direction.name }}
            </button>
          }
        </div>
      }

      <div
        class="pt-transactions__filters-controls"
        [formGroup]="filtersForm"
      >
        @if (filtersForm.controls.direction.value === 'income') {
          <pu-select
            class="pt-transactions__filters-controls-select"
            formControlName="metric"
            [items]="incomeMetrics() | withAllOption"
            [label]="'transactions.filters.status' | translate"
          />
        }

        @if (filtersForm.controls.direction.value === 'expense') {
          <pu-select
            class="pt-transactions__filters-controls-select"
            formControlName="metric"
            [items]="expenseMetrics() | withAllOption"
            [label]="'transactions.filters.status' | translate"
          />
        }

        <pu-select
          class="pt-transactions__filters-controls-select"
          formControlName="period"
          [items]="periods"
          [label]="'transactions.filters.period' | translate"
        />
      </div>
    </div>

    @if (dialog()) {
      <div class="pu-shadow-dialog pu-shadow-dialog_visible"></div>
    } @else {
      <div
        class="pu-scroll-shadow"
        [class.pu-scroll-shadow_visible]="uiStore.isHeaderShadowVisible()"
      >
      </div>
    }
  </div>

  <ul class="pt-transactions__transactions">
    @for (transaction of store.transactions(); track transaction.id) {
      <li
        class="pt-transactions__transaction"
        ptTransaction
        [transaction]="transaction"
      >
      </li>
    } @empty {
      @if (!isLoading()) {
        <pu-empty
          iconName="transactions"
          titleKey="transactions.empty.title"
          btnKey="transactions.empty.controls.transactionsPage"
          [btnLink]="project === 'pt' ? transactionsSegment : ''"
          [secondaryBtnLink]="project === 'pt' ? '/' : ''"
        />
      }
    }
  </ul>

  @if (store.itemsCount() > store.filters.limit()) {
    <div class="pt-transactions__paginator">
      <mat-paginator
        [length]="store.itemsCount()"
        [pageSize]="store.filters.limit()"
        [showFirstLastButtons]="true"
        [pageSizeOptions]="[30, 50, 100]"
        [hidePageSize]="true"
        [pageIndex]="store.filters.page() - 1"
        (page)="onPageChange($event)"
        aria-label="Select page"
      />
    </div>
  }

  @if (store.itemsCount()) {
    @let charts = store.charts();
    <div
      class="pt-transactions__totals"
      [class.pt-transactions__totals_hidden]="!dialog()
      && uiStore.isNavbarHidden() && !uiStore.isDesktop()"
    >
      @if (isMetricTotal()) {
        <pt-transaction-metric-total [chart]="charts[0]"/>
      } @else {
        @if (showMore() || charts.length === 1) {
          @if (charts.length > 1) {
            <button
              class="pt-transactions__btn-hide-statistic"
              type="button"
              puButton
              uiType="quaternary"
              size="m"
              (click)="toggleShowMore()"
            >
              {{ 'transactions.total.btn.hideStatistic' | translate }}
            </button>
          }

          <div
            class="pt-transactions__donuts"
            [class.pt-transactions__donuts_1]="charts.length === 1"
            [class.pt-transactions__donuts_3]="charts.length === 3"
          >
            @for (chart of charts; track chart.id) {
              <pt-transaction-donut-total [chart]="chart"/>
            }
          </div>
        } @else {
          <div class="pt-transactions__text-totals">
            <pt-transaction-text-total [chart]="charts[0]"/>

            @if (charts.length > 1) {
              <pt-transaction-text-total [chart]="charts[1]"/>
            }

            <button
              type="button"
              puButton
              uiType="quaternary"
              size="m"
              (click)="toggleShowMore()"
            >
              {{ 'transactions.total.btn.viewMore' | translate }}
            </button>
          </div>
        }
      }
    </div>
  }
</div>
